import { RootState } from 'store';

export const selectStatus = (state:RootState) => state.payments.status;
export const selectErrorMessage = (state:RootState) => state.payments.errorMessage;
